// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"1794":"6fd99df0bb5d5da7","3362":"88371329111e0dd4","4886":"a9bbb82c2445ffec","5559":"8c965a7b250f5c2a","7026":"2c78d8464ee7a20d","8022":"9d3b7b6daf7b281c"}[chunkId] + ".css";
};